import Vue from "vue";
import Vuetify from "vuetify/lib";
import ja from "vuetify/es5/locale/ja.js";

Vue.use(Vuetify);

ja.noDataText = "検索結果が見つかりません。";

export default new Vuetify({
  lang: {
    locales: { ja },
    current: "ja"
  }
});
